// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar container */
.navbar {
    display: flex;
    justify-content: start;
    background-color: #F9FAFB;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 16px;
    width: fit-content;
}

/* Button styles for tabs */
.navbar button {
    padding: 8px 20px;
    border: none;
    background: transparent;
    font-size: 16px;
    font-weight: bold;
    color: #4B5563;
    cursor: pointer;
    border-radius: 6px;
    transition: background-color 0.3s ease, color 0.3s ease;
}

/* Active tab button */
.navbar button.active {
    background-color: #2196F3; /* Blue background for active tab */
    color: white;
}

/* Hover effect for non-active buttons */
.navbar button:not(.active):hover {
    background-color: #E5E7EB; /* Light gray on hover */
    color: #2196F3;
}

/* Other container styles */
.points-container {
    margin-left: 250px;
    padding: 16px;
    width: calc(100% - 250px);
    background: #FFFFFF;
    border-radius: 12px;
}

.points-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
}

.points-table th, .points-table td {
    padding: 16px;
    border-bottom: 1px solid #DFE7EF;
    font-size: 16px;
    color: #4B5563;
}

.points-table th {
    font-weight: bold;
    background-color: #F9FAFB;
}

.view-button, .edit-button, .delete-button, .add-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.view-button { background-color: #4CAF50; color: white; }
.edit-button { background-color: #2196F3; color: white; }
.delete-button { background-color: #FF5252; color: white; }
.add-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #FF9800;
    color: white;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: bold;
    border-radius: 8px;
    cursor: pointer;
}

.map-view-container {
    height: 600px; /* Adjust as needed */
    width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/style/PointsList.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA,sBAAsB;AACtB;IACI,yBAAyB,EAAE,mCAAmC;IAC9D,YAAY;AAChB;;AAEA,wCAAwC;AACxC;IACI,yBAAyB,EAAE,wBAAwB;IACnD,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,2DAA2D;AAC/D;;AAEA,eAAe,yBAAyB,EAAE,YAAY,EAAE;AACxD,eAAe,yBAAyB,EAAE,YAAY,EAAE;AACxD,iBAAiB,yBAAyB,EAAE,YAAY,EAAE;AAC1D;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa,EAAE,qBAAqB;IACpC,WAAW;AACf","sourcesContent":["/* Navbar container */\n.navbar {\n    display: flex;\n    justify-content: start;\n    background-color: #F9FAFB;\n    border-radius: 8px;\n    padding: 8px;\n    margin-bottom: 16px;\n    width: fit-content;\n}\n\n/* Button styles for tabs */\n.navbar button {\n    padding: 8px 20px;\n    border: none;\n    background: transparent;\n    font-size: 16px;\n    font-weight: bold;\n    color: #4B5563;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Active tab button */\n.navbar button.active {\n    background-color: #2196F3; /* Blue background for active tab */\n    color: white;\n}\n\n/* Hover effect for non-active buttons */\n.navbar button:not(.active):hover {\n    background-color: #E5E7EB; /* Light gray on hover */\n    color: #2196F3;\n}\n\n/* Other container styles */\n.points-container {\n    margin-left: 250px;\n    padding: 16px;\n    width: calc(100% - 250px);\n    background: #FFFFFF;\n    border-radius: 12px;\n}\n\n.points-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n}\n\n.points-table th, .points-table td {\n    padding: 16px;\n    border-bottom: 1px solid #DFE7EF;\n    font-size: 16px;\n    color: #4B5563;\n}\n\n.points-table th {\n    font-weight: bold;\n    background-color: #F9FAFB;\n}\n\n.view-button, .edit-button, .delete-button, .add-button {\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: bold;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.view-button { background-color: #4CAF50; color: white; }\n.edit-button { background-color: #2196F3; color: white; }\n.delete-button { background-color: #FF5252; color: white; }\n.add-button {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    background-color: #FF9800;\n    color: white;\n    padding: 12px 20px;\n    font-size: 14px;\n    font-weight: bold;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.map-view-container {\n    height: 600px; /* Adjust as needed */\n    width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
